import styled from "styled-components";
export const FAQtg = styled.a`
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  color: #55749f;
  display: inline;
  text-decoration: none;
  cursor: pointer;
`;
export const FAQTitle = styled.div`
  font-family: Cormorant Infant;
  font-size: 60px;
  font-weight: 500;
  text-align: left;
  margin-bottom: 10px;
`;
export const FAQText = styled.div`
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  text-align: top;
  display: inline;
  @media (max-width: 430px) {
    font-size: 15px;
  }
`;
export const FAQCont1 = styled.div`
  width: 600px;
  @media (max-width: 430px) {
    width: 393px;
    margin-left: 20px;
  }
`;
